import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('privacy');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-header">
        <div className="privacy-policy-header-content">
          <h1>{t('header.title')}</h1>
          <p className="privacy-policy-subtitle">
            {t('header.subtitle')}
          </p>
          <p className="privacy-policy-date">{t('header.lastUpdated')}</p>
        </div>
      </div>

      <div className="privacy-policy-content">
        <nav className="privacy-policy-nav">
          <h3>{t('navigation.title')}</h3>
          <ul>
            <li><a href="#introduction">{t('navigation.introduction')}</a></li>
            <li><a href="#information-we-collect">{t('navigation.informationWeCollect')}</a></li>
            <li><a href="#how-we-use">{t('navigation.howWeUse')}</a></li>
            <li><a href="#data-sharing">{t('navigation.dataSharing')}</a></li>
            <li><a href="#data-security">{t('navigation.dataSecurity')}</a></li>
            <li><a href="#your-rights">{t('navigation.yourRights')}</a></li>
            <li><a href="#cookies">{t('navigation.cookies')}</a></li>
            <li><a href="#children">{t('navigation.children')}</a></li>
            <li><a href="#international">{t('navigation.international')}</a></li>
            <li><a href="#changes">{t('navigation.changes')}</a></li>
            <li><a href="#contact">{t('navigation.contact')}</a></li>
            <li><a href="#consent">{t('navigation.consent')}</a></li>
          </ul>
        </nav>

        <div className="privacy-policy-main">
          <section id="introduction">
            <h2>{t('introduction.title')}</h2>
            <p>{t('introduction.description1')}</p>
            <p>{t('introduction.description2')}</p>
          </section>

          <section id="information-we-collect">
            <h2>{t('informationWeCollect.title')}</h2>
            
            <h3>{t('informationWeCollect.directInformation.title')}</h3>
            <ul>
              <li><strong>{t('informationWeCollect.directInformation.accountInfo')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.profileDetails')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.vehicleInfo')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.tripInfo')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.packageDetails')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.communicationData')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.paymentInfo')}</strong></li>
              <li><strong>{t('informationWeCollect.directInformation.reviewsRatings')}</strong></li>
            </ul>

            <h3>{t('informationWeCollect.automaticInformation.title')}</h3>
            <ul>
              <li><strong>{t('informationWeCollect.automaticInformation.locationData')}</strong></li>
              <li><strong>{t('informationWeCollect.automaticInformation.deviceInfo')}</strong></li>
              <li><strong>{t('informationWeCollect.automaticInformation.usageData')}</strong></li>
              <li><strong>{t('informationWeCollect.automaticInformation.ipAddress')}</strong></li>
              <li><strong>{t('informationWeCollect.automaticInformation.cookiesTech')}</strong></li>
            </ul>

            <h3>{t('informationWeCollect.thirdPartyInfo.title')}</h3>
            <ul>
              <li><strong>{t('informationWeCollect.thirdPartyInfo.oauthProviders')}</strong></li>
              <li><strong>{t('informationWeCollect.thirdPartyInfo.paymentProcessors')}</strong></li>
              <li><strong>{t('informationWeCollect.thirdPartyInfo.mapServices')}</strong></li>
            </ul>
          </section>

          <section id="how-we-use">
            <h2>{t('howWeUse.title')}</h2>
            
            <h3>{t('howWeUse.primaryUses.title')}</h3>
            <ul>
              <li><strong>{t('howWeUse.primaryUses.serviceDelivery')}</strong></li>
              <li><strong>{t('howWeUse.primaryUses.accountManagement')}</strong></li>
              <li><strong>{t('howWeUse.primaryUses.matchingServices')}</strong></li>
              <li><strong>{t('howWeUse.primaryUses.routeOptimization')}</strong></li>
              <li><strong>{t('howWeUse.primaryUses.communication')}</strong></li>
              <li><strong>{t('howWeUse.primaryUses.safetyTrust')}</strong></li>
            </ul>

            <h3>{t('howWeUse.additionalUses.title')}</h3>
            <ul>
              <li><strong>{t('howWeUse.additionalUses.improvements')}</strong></li>
              <li><strong>{t('howWeUse.additionalUses.customerSupport')}</strong></li>
              <li><strong>{t('howWeUse.additionalUses.legalCompliance')}</strong></li>
              <li><strong>{t('howWeUse.additionalUses.marketing')}</strong></li>
              <li><strong>{t('howWeUse.additionalUses.statistics')}</strong></li>
              <li><strong>{t('howWeUse.additionalUses.fraudPrevention')}</strong></li>
            </ul>
          </section>

          <section id="data-sharing">
            <h2>{t('dataSharing.title')}</h2>
            
            <h3>{t('dataSharing.sharingWithUsers.title')}</h3>
            <p>{t('dataSharing.sharingWithUsers.description')}</p>
            <ul>
              <li><strong>{t('dataSharing.sharingWithUsers.publicProfile')}</strong></li>
              <li><strong>{t('dataSharing.sharingWithUsers.tripParticipants')}</strong></li>
              <li><strong>{t('dataSharing.sharingWithUsers.locationData')}</strong></li>
              <li><strong>{t('dataSharing.sharingWithUsers.reviews')}</strong></li>
            </ul>

            <h3>{t('dataSharing.serviceProviders.title')}</h3>
            <p>{t('dataSharing.serviceProviders.description')}</p>
            <ul>
              <li><strong>{t('dataSharing.serviceProviders.supabase')}</strong></li>
              <li><strong>{t('dataSharing.serviceProviders.stripe')}</strong></li>
              <li><strong>{t('dataSharing.serviceProviders.googleMaps')}</strong></li>
              <li><strong>{t('dataSharing.serviceProviders.cloudflare')}</strong></li>
              <li><strong>{t('dataSharing.serviceProviders.resend')}</strong></li>
            </ul>

            <h3>{t('dataSharing.legalRequirements.title')}</h3>
            <p>{t('dataSharing.legalRequirements.description')}</p>
            <ul>
              <li>{t('dataSharing.legalRequirements.comply')}</li>
              <li>{t('dataSharing.legalRequirements.protect')}</li>
              <li>{t('dataSharing.legalRequirements.prevent')}</li>
              <li>{t('dataSharing.legalRequirements.liability')}</li>
            </ul>

            <h3>{t('dataSharing.businessTransfers.title')}</h3>
            <p>{t('dataSharing.businessTransfers.description')}</p>

            <h3>{t('dataSharing.aggregatedData.title')}</h3>
            <p>{t('dataSharing.aggregatedData.description')}</p>
          </section>

          <section id="data-security">
            <h2>{t('dataSecurity.title')}</h2>
            <p>{t('dataSecurity.description')}</p>
            <ul>
              <li><strong>{t('dataSecurity.encryption')}</strong></li>
              <li><strong>{t('dataSecurity.accessControls')}</strong></li>
              <li><strong>{t('dataSecurity.secureInfrastructure')}</strong></li>
              <li><strong>{t('dataSecurity.regularUpdates')}</strong></li>
              <li><strong>{t('dataSecurity.passwordSecurity')}</strong></li>
              <li><strong>{t('dataSecurity.twoFactor')}</strong></li>
            </ul>
            <p>{t('dataSecurity.disclaimer')}</p>
          </section>

          <section id="your-rights">
            <h2>{t('yourRights.title')}</h2>
            
            <h3>{t('yourRights.gdprRights.title')}</h3>
            <p>{t('yourRights.gdprRights.description')}</p>
            <ul>
              <li><strong>{t('yourRights.gdprRights.access')}</strong></li>
              <li><strong>{t('yourRights.gdprRights.rectification')}</strong></li>
              <li><strong>{t('yourRights.gdprRights.erasure')}</strong></li>
              <li><strong>{t('yourRights.gdprRights.restriction')}</strong></li>
              <li><strong>{t('yourRights.gdprRights.portability')}</strong></li>
              <li><strong>{t('yourRights.gdprRights.objection')}</strong></li>
              <li><strong>{t('yourRights.gdprRights.automatedDecisions')}</strong></li>
            </ul>

            <h3>{t('yourRights.managingInfo.title')}</h3>
            <ul>
              <li><strong>{t('yourRights.managingInfo.profileSettings')}</strong></li>
              <li><strong>{t('yourRights.managingInfo.communicationPrefs')}</strong></li>
              <li><strong>{t('yourRights.managingInfo.locationServices')}</strong></li>
              <li><strong>{t('yourRights.managingInfo.accountDeletion')}</strong></li>
              <li><strong>{t('yourRights.managingInfo.dataExport')}</strong></li>
            </ul>

            <h3>{t('yourRights.retentionPeriod.title')}</h3>
            <p>{t('yourRights.retentionPeriod.description')}</p>
          </section>

          <section id="cookies">
            <h2>{t('cookies.title')}</h2>
            
            <h3>{t('cookies.typesOfCookies.title')}</h3>
            <ul>
              <li><strong>{t('cookies.typesOfCookies.essential')}</strong></li>
              <li><strong>{t('cookies.typesOfCookies.preference')}</strong></li>
              <li><strong>{t('cookies.typesOfCookies.analytics')}</strong></li>
              <li><strong>{t('cookies.typesOfCookies.session')}</strong></li>
            </ul>

            <h3>{t('cookies.managingCookies.title')}</h3>
            <p>{t('cookies.managingCookies.description')}</p>

            <h3>{t('cookies.doNotTrack.title')}</h3>
            <p>{t('cookies.doNotTrack.description')}</p>
          </section>

          <section id="children">
            <h2>{t('children.title')}</h2>
            <p>{t('children.description1')}</p>
            <p>{t('children.description2')}</p>
          </section>

          <section id="international">
            <h2>{t('international.title')}</h2>
            <p>{t('international.description')}</p>
          </section>

          <section id="changes">
            <h2>{t('changes.title')}</h2>
            <p>{t('changes.description')}</p>
            <ul>
              <li>{t('changes.posting')}</li>
              <li>{t('changes.updating')}</li>
              <li>{t('changes.email')}</li>
              <li>{t('changes.notification')}</li>
            </ul>
            <p>{t('changes.continued')}</p>
          </section>

          <section id="contact">
            <h2>{t('contact.title')}</h2>
            <p>{t('contact.description')}</p>
            <div className="contact-info-box">
              <p><strong>{t('contact.contactInfo.title')}</strong></p>
              <p>{t('contact.contactInfo.email')}</p>
              <p>{t('contact.contactInfo.general')}</p>
              <p>{t('contact.contactInfo.address')}</p>
              <p>{t('contact.contactInfo.website')}</p>
            </div>
            <p>{t('contact.gdprComplaint')}</p>
          </section>

          <section id="consent">
            <h2>{t('consent.title')}</h2>
            <p>{t('consent.description')}</p>
          </section>
        </div>
      </div>

      <div className="privacy-policy-footer">
        <button onClick={() => navigate(-1)} className="privacy-back-button">
          {t('buttons.goBack')}
        </button>
        <button onClick={() => navigate('/')} className="privacy-home-button">
          {t('buttons.homePage')}
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
